<template>
    <div class="grid-container">
        <div class="grid-item grid-item-2-rows">
            <h3 class="section-title bigEntrance">
                <font-awesome-icon icon="cogs"/>
                Service
            </h3>
            <p class="content-block stretchRight">
                Wir entwickeln iOS-Applikationen und gleich auch die passende Backend-Komponente dazu.
                Dies richtig gut und State of the Art.

                Als technischer Umsetzungspartner begleiten wir unsere Kunden von der Idee über Konzeption bis zur
                konkreten Implementation und anschliessender Nachbetreuung ihrer Projekte.
                Sind bereits fertig ausgearbeitete Designs oder Konzepte vorhanden, setzen wir diese sorgfältig und
                äusserst effizient um.

                Damit auch die Qualität stimmt, arbeiten wir iterativ-inkrementell und testen sämtlich ausgeführte
                Arbeiten automatisiert.
                Unsere Kunden erhalten somit in regelmässigen Abständen Vorabversionen ihrer Software und können
                diese einer laufenden Revision unterziehen. Dies spart Zeit, Nerven und vor allem Kosten.
            </p>
        </div>
        <div class="grid-item">
            <h3 class="section-title bounce">
                <font-awesome-icon icon="users"/>
                Team
            </h3>
            <p class="content-block pullDown">
                Naptics setzt sich zusammen aus Jonas Schoch und Fabian Spring, zwei leidenschaftliche
                Softwareentwicklungs-Ingenieure.
                Wir sind ein kleines, perfekt eingespieltes Team mit zusammen über fünfzehn Jahren Erfahrung in der
                Software-Entwicklung.
                Somit bringen wir alles mit, was es braucht, um aussergewöhnliche Arbeit zu leisten und für unsere
                Kunden effizient, qualitativ hochstehende Software zu schreiben.
            </p>
        </div>
        <div class="grid-item">
            <h3 class="section-title hatch">
                <font-awesome-icon icon="link"/>
                Membership
            </h3>
            <a href="http://www.swissmadesoftware.org" target="_blank">
                <img class="grayscale hatch" style="height:40px" alt="Swiss Made Software" src="/static/img/swissmadesoftware_logo.jpg" />
            </a>
        </div>
    </div>
</template>

<script>
    import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

    export default {
        name: 'ServiceTeamMembership',

        components: {
            FontAwesomeIcon
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/main";
    @import "../styles/animations";

    .section-title {
        color: #ff5519;
        font-family: "PxGrotesk-Regular", sans-serif;
    }

    img.grayscale { /* 7f8c8d */
        filter: url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\'><filter id=\'grayscale\'><feColorMatrix type=\'matrix\' values=\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\'/></filter></svg>#grayscale"); /* Firefox 3.5+ */
        opacity: 0.7;
        -webkit-filter: grayscale(100%); /* Chrome 19+ & Safari 6+ */
        -webkit-transition: all .5s ease-in-out;
        -webkit-backface-visibility: hidden; /* Fix for transition flickering */
        -moz-filter: grayscale(100%);
        -moz-transition: .5s ease-in-out;
        -o-filter: grayscale(100%);
        -o-transition: .5s ease-in-out;
    }

    img.grayscale:hover {
        filter: none;
        opacity: 1.0;
        -webkit-filter: grayscale(0%);
        -webkit-transition: .5s ease-in-out;
        -moz-filter: grayscale(0%);
        -moz-transition: .5s ease-in-out;
        -o-filter: grayscale(0%);
        -o-transition: .5s ease-in-out;
    }

    .content-block {
        font-family: "PxGrotesk-Light", sans-serif;
        font-size: 14px;
        line-height: 1.75em;
    }

</style>



// WEBPACK FOOTER //
// src/components/ServiceTeamMembership.vue